const LOCATION_GID_PREFIX = "gid://shopify/Location/";

function locationGidFromReference(value) {
  if (value == null || value === "") {
    return null;
  }

  const stringValue = String(value);
  const gidIndex = stringValue.lastIndexOf(LOCATION_GID_PREFIX);

  if (gidIndex >= 0) {
    return stringValue.slice(gidIndex);
  }

  return `${LOCATION_GID_PREFIX}${stringValue}`;
}

function storeHasCoordinates(store) {
  if (!store.address) {
    return false;
  }

  const { latitude, longitude } = store.address;

  return latitude && longitude;
}

class Stores {
  constructor() {
    this.query = `
      query GetStores($first: Int!, $after: String) {
        metaobjects(type: "store", first: $first, after: $after) {
          nodes {
            id
            handle
            type
            fields {
              key
              type
              value
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;

    this.getStores();
  }

  async getStores() {
    if (WYATT.shopify.stores) {
      WYATT.PubSub.publish(
        WYATT.PubSub.events.storesFetched,
        WYATT.shopify.stores,
      );

      window.sessionStorage.setItem(
        WYATT.config.stores.sessionStorageKey,
        JSON.stringify(WYATT.shopify.stores),
      );

      return;
    }

    const stores = await this.fetchAllPages();

    WYATT.shopify.stores = stores.filter(storeHasCoordinates);
    WYATT.PubSub.publish(
      WYATT.PubSub.events.storesFetched,
      WYATT.shopify.stores,
    );

    window.sessionStorage.setItem(
      WYATT.config.stores.sessionStorageKey,
      JSON.stringify(WYATT.shopify.stores),
    );
  }

  async fetchPage(after = null) {
    const options = {
      method: "post",
      headers: WYATT.config.api.headers,
      body: JSON.stringify({
        query: this.query,
        variables: { first: 50, after },
      }),
    };

    const response = await fetch(WYATT.config.api.endpoint, options);

    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }

    return response.json();
  }

  async fetchAllPages(after = null, accumulated = []) {
    const parsedResponse = await this.fetchPage(after);
    const { nodes, pageInfo } = parsedResponse.data.metaobjects;
    const stores = [...accumulated, ...this.formatNodes(nodes)];

    if (pageInfo.hasNextPage) {
      return this.fetchAllPages(pageInfo.endCursor, stores);
    }

    return stores;
  }

  formatNodes(nodes) {
    return nodes.map((node) => ({
      id: node.id,
      handle: node.handle,
      ...Object.fromEntries(
        node.fields.map((field) => [field.key, this.parseFieldValue(field)]),
      ),
    }));
  }

  parseFieldValue(field) {
    if (field.value === null || field.value === undefined) {
      return null;
    }

    if (field.key === "location_id") {
      return locationGidFromReference(field.value);
    }

    switch (field.type) {
      case "number_integer":
        return parseInt(field.value, 10);
      case "number_decimal":
        return parseFloat(field.value);
      case "boolean":
        return field.value === "true";
      case "json":
        try {
          return JSON.parse(field.value);
        } catch {
          return field.value;
        }
      case "location_reference":
        return locationGidFromReference(field.value);
      default:
        return field.value;
    }
  }
}

WYATT.Stores = new Stores();

export default Stores;
